import React, { useEffect, useState } from "react";
import {
  Calendar,
  FileText,
  ChevronRight,
  Clock,
  CalendarCheck,
  Edit,
  DollarSign,
  Check,
  X,
  ArrowLeft,
  Plus,
  PenToolIcon as Tool,
} from "lucide-react";
import GreyArrow from "../assets/greyLeftAr.png";
import { Button, ButtonGroup } from "@mui/material";
import "./Css/PickUpForm.css";
import Header from "./Header";
import { Modal } from "react-bootstrap";
import {
  APL_LINK,
  server_post_data,
  get_pickup_data_admin,
  save_image_pdf_dashboard,
  submit_update_pickup_data,
  save_car_ipass_data,
} from "../ServiceConnection/serviceconnection";
import "react-datepicker/dist/react-datepicker.css";
import "./fuel-gauge-animation.js";
import DatePicker from "react-datepicker";
import {
  handleAphabetsChange,
  handleError,
  handleNumbersChange,
  handleSuccess,
  handleSuccessSession,
  goBack,
  formatToYYYYMMDD,
} from "../CommonJquery/CommonJquery";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "./Loader.js";
import Breadcrumb from "../CommonJquery/Breadcrumb.js";
import UserIconOrenge from "../assets/UserIconOrenge.svg";
export default function PickUpForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(1);
  const [carData, setCarData] = useState([]);
  const [oldeDueData, setOlderDueData] = useState(null);
  const [oldeDueCarry, setOldeDueCarry] = useState(0);
  const [BookingData, setBookingData] = useState([]);
  const [caripass, setCaripass] = useState([]);
  const [MultiCarData, setMultiCarData] = useState([]);
  const [ipassid, setipassid] = useState("");
  const [ipassnumber, setipassnumber] = useState("");
  const [formData, setFormData] = useState({
    backdate_entry: null,
    back_entry_reason: "",
    pickup_date: null,
    first_name: "",
    last_name: "",
    gaslavel: "",
    ipass: "",
    odoReading: "",
    insurance: "",
    time: "",
    dashboardOdoImage: null,

    ipassImg: null,

    frontLeft: null,
    frontRight: null,
    backLeft: null,
    backRight: null,
    keyImg: null,
    InsuranceCopy: null,
    vinnumber: "",
    maintenance_due: new Date().toISOString().split("T")[0],
    registration_copy: null,
    inspection_copy: null,
    notes: "",
    ipass_owner: "Company Owned",
  });
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [imageLink, setImageLink] = useState("");
  const [agreementChecked, setAgreementChecked] = useState(true);
  const [paymentChecked, setPaymentChecked] = useState(false);
  // const [checkedItems, setCheckedItems] = useState([]);
  const [checkedItems, setCheckedItems] = useState([
    "Insurance",
    "Registration",
    "Inspection", // ✅ default checked ones
  ]);
  const [userId, setUserId] = useState("");
  const [VINNo, setVINNo] = useState("");
  const [step1Error, setStep1Error] = useState({
    pickup_date: false,
    backdate_entry: false,
    back_entry_reason: false,
    first_name: false,
    last_name: false,
    agreement: false,
    payment: false,
    insurance: false,
    time: false,
  });
  const [step2Error, setStep2Error] = useState({
    gaslavel: false,
    odoReading: false,
    ipassImg: false,
    keyImg: false,
    frontLeft: false,
    frontRight: false,
    backLeft: false,
    backRight: false,
    ipass: false,
    dashboardOdoImage: false,
  });
  const [step3Error, setStep3Error] = useState({
    maintenance_due: false,
    InsuranceCopy: false,
    registration_copy: false,
    vinnumber: false,
  });
  const [step4Error, setStep4Error] = useState({
    checkedItems: false,
  });
  const [duescontnt, setduescontnt] = useState(
    "The driver has outstanding dues of previous booking. Do you want to carry forward these dues in this Booking?"
  );
  const [dueModal, setDueModal] = useState(null);

  const checkboxes = [
    "Insurance",
    "Registration",
    "Inspection",
    "2nd Key Check",
  ];

  // State to hold the checked values
  //console.log("formData", formData);
  const handleCheckboxChange = (label) => {
    setCheckedItems((prevState) => {
      if (!Array.isArray(prevState)) return [];

      const updatedCheckedItems = prevState.includes(label)
        ? prevState.filter((item) => item !== label)
        : [...prevState, label];

      // update error state via setter
      setStep4Error((prev) => ({
        ...prev,
        checkedItems: !(updatedCheckedItems.length === checkboxes.length),
      }));

      return updatedCheckedItems;
    });
  };
  const validateStep1 = () => {
    const today = new Date().toISOString().split("T")[0];
    const pickupDateStr = formData.pickup_date
      ? new Date(formData.pickup_date).toISOString().split("T")[0]
      : null;
    const reason = formData.back_entry_reason;
    const errors = {
      backdate_entry: !formData.backdate_entry,
      // back_entry_reason: formData.back_entry_reason === "",
      back_entry_reason:
        formData.backdate_entry === "yes" && pickupDateStr !== today
          ? !reason || reason.toString().trim() === ""
          : false,
      pickup_date: !formData.pickup_date,
      first_name: formData.first_name === "",
      last_name: formData.last_name === "",
      agreement: !agreementChecked,
      payment: !paymentChecked,
      insurance: formData.insurance === "",
      time: formData.time === "",
    };

    return errors;
  };
  const validateStep2 = () => {
    const errors2 = {
      gaslavel: formData.gaslavel === "",
      odoReading: formData.odoReading === "",
      dashboardOdoImage: !formData.dashboardOdoImage,

      ipass: formData?.ipass === "" || formData?.ipass === null,
      ipassImg: !formData.ipassImg,
      keyImg: !formData.keyImg,
      frontLeft: !formData.frontLeft,
      frontRight: !formData.frontRight,
      backLeft: !formData.backLeft,
      backRight: !formData.backRight,
    };
    console.log("formData.ipass", formData.ipass);
    return errors2;
  };
  // const validateStep3 = () => {
  //   const errors3 = {
  //     maintenance_due: !formData.maintenance_due,
  //     InsuranceCopy: !formData.InsuranceCopy,

  //     registration_copy: !formData.registration_copy,
  //     inspection_copy: !formData.inspection_copy,
  //     vinnumber: !formData.vinnumber || formData.vinnumber.length !== 6,
  //   };

  //   return errors3;
  // };
  const [errors, setErrors] = useState({});
  const validateStep3 = () => {
    const last6 = VINNo?.slice(-6);

    let vinnumberError = "";
    let vin = false;
    if (!formData.vinnumber) {
      vinnumberError = "VIN is required";
      vin = true;
    } else if (formData.vinnumber.length !== 6) {
      vinnumberError = "VIN must be exactly 6 digits";
      vin = true;
    } else if (formData.vinnumber !== last6) {
      vinnumberError = "VIN does not match our records";
      vin = true;
    }

    const errors3 = {
      maintenance_due: !formData.maintenance_due,
      InsuranceCopy: !formData.InsuranceCopy,
      registration_copy: !formData.registration_copy,
      inspection_copy: !formData.inspection_copy,
      vinnumber: vinnumberError,
      vin: vin,
    };
    setErrors(errors3);
    return errors3;
  };
  const validateStep4 = () => {
    const errors4 = {
      checkedItems: !checkedItems.includes("2nd Key Check"),
    };

    return errors4;
  };

  const handleAgreementChange = () => {
    const newAgreementChecked = !agreementChecked;
    setAgreementChecked(newAgreementChecked);
    setStep1Error((prev) => ({
      ...prev,
      agreement: !newAgreementChecked ? true : false,
    }));
  };
  const handlePaymentChange = () => {
    const newPaymentChecked = !paymentChecked;
    setPaymentChecked(newPaymentChecked);
    setStep1Error((prev) => ({
      ...prev,
      payment: !newPaymentChecked ? true : false,
    }));
  };
  const handleDateChange = (date, fieldName, errorStateSetter) => {
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: date,
    }));
    errorStateSetter((prev) => ({
      ...prev,
      [fieldName]: !date,
    }));
  };
  const handleInputChange = (e, field, step) => {
    // Update the form data
    console.log("field", field, e.target.value);
    if (field === "ipass") {
      setipassid(e.target.value);
      const selectedOption = caripass.find(
        (option) => option.primary_id == e.target.value
      );
      if (selectedOption) {
        setipassnumber(selectedOption.ipass_id);
      } else {
        setipassnumber(""); // or handle it as you want when not found
        console.warn("No matching option found for", e.target.value);
      }
      setFormData((prevData) => ({
        ...prevData,
        [field]: e.target.value,
        ipass: selectedOption ? selectedOption.ipass_id : "",
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [field]: e.target.value,
      }));
    }

    if (field === "vinnumber") {
      // For VIN number, check if it has exactly 8 digits
      if (e.target.value.trim() !== "" && e.target.value.length <= 6) {
        setStep3Error((prev) => ({ ...prev, [field]: false }));
        //console.log("FASLE");
      } else {
        setStep3Error((prev) => ({ ...prev, [field]: true }));
        //console.log("TRUE");
      }
    } else {
      // For other fields, just check if they're not empty
      if (e.target.value.trim() !== "") {
        if (step === 1) {
          setStep1Error((prev) => ({ ...prev, [field]: false }));
        } else if (step === 2) {
          setStep2Error((prev) => ({ ...prev, [field]: false }));
        } else if (step === 3) {
          setStep3Error((prev) => ({ ...prev, [field]: false }));
        }
      }
    }
  };

  useEffect(() => {
    // Initialize the fuel gauge animation when the component mounts
    if (window.initializeFuelGauge) {
      window.initializeFuelGauge();
    }
  }, []);

  // Handle gas level input
  const handleGasLevelChange = (e) => {
    const newValue = e.target.value;
    setFormData({
      ...formData,
      gaslavel: newValue,
    });

    // Update the custom fuel gauge animation
    if (window.updateFuelGauge) {
      window.updateFuelGauge(newValue);
    }
  };

  const handleFileChange = async (e, field) => {
    handleSaveImageBackend(e.target.files[0], "single", field);
    if (e.target.files[0]) {
      setStep2Error((prev) => ({ ...prev, [field]: false }));
    }
  };
  const handleFileChange2 = async (e, field) => {
    handleSaveImageBackend(e.target.files[0], "single", field);
    if (e.target.files[0]) {
      setStep3Error((prev) => ({ ...prev, [field]: false }));
    }
  };
  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };
  const handleNext = (e, step) => {
    e.preventDefault();
    const errors = validateStep1();

    setStep1Error(errors);
    console.log(errors);

    if (Object.values(errors).includes(true)) {
      //console.log("Form has errors");
      return;
    }
    setActiveStep(2);
    // //console.log("Form submitted", formData);
  };
  const handleNext2 = (e, step) => {
    e.preventDefault();
    const errors2 = validateStep2();
    setStep2Error(errors2);
    if (Object.values(errors2).includes(true)) {
      //console.log("Form has errors2");
      return;
    }
    if (formData.vinnumber && formData.vinnumber.length !== 8) {
      setStep3Error((prev) => ({
        ...prev,
        vinnumber: true,
      }));
    }
    setActiveStep(3);
    // //console.log("Form submitted", formData);
  };
  const handleNext3 = (e, step) => {
    e.preventDefault();
    const errors3 = validateStep3();
    console.log("errors3", errors3);
    setStep3Error(errors3);
    if (Object.values(errors3).includes(true)) {
      //console.log("Form has errors3");
      return;
    }
    setActiveStep(4);
    // //console.log("Form submitted", formData);
  };
  const handleNext4 = async (e, step) => {
    e.preventDefault();
    const errors4 = validateStep4();
    setStep4Error(errors4);
    if (Object.values(errors4).includes(true)) {
      // //console.log("Form has errors4");
      return;
    }

    let fd_from = new FormData();
    fd_from.append("primary_id", id);
    fd_from.append("pickup_date", formatToYYYYMMDD(formData.pickup_date));
    fd_from.append("fname", formData.first_name);
    fd_from.append("lname", formData.last_name);
    fd_from.append("gas_ievel", formData.gaslavel);
    fd_from.append("ipass_id", ipassid || formData.ipass);
    fd_from.append("ipassnumber", ipassnumber);
    fd_from.append("odo_reading", formData.odoReading);
    fd_from.append("Insurance", formData.insurance);
    fd_from.append("pickup_time", formData.time);
    fd_from.append("gas_and_odo_image", formData.dashboardOdoImage);
    fd_from.append("ipass_picture", formData.ipassImg);
    fd_from.append("key_image", formData.keyImg);
    fd_from.append("Insurance_image", formData.InsuranceCopy);
    fd_from.append("vin", formData.vinnumber);
    fd_from.append("last_maintenance_date", formData.maintenance_due);
    fd_from.append("registration", formData.registration_copy);
    fd_from.append("inspection", formData.inspection_copy);
    fd_from.append("notes", formData.notes);
    fd_from.append("car_image", JSON.stringify(MultiCarData));
    fd_from.append("aggriment_status", agreementChecked === true ? 1 : 0);
    fd_from.append("payment_status", paymentChecked === true ? 1 : 0);
    fd_from.append("frontLeft", formData.frontLeft);
    fd_from.append("frontRight", formData.frontRight);
    fd_from.append("backLeft", formData.backLeft);
    fd_from.append("backRight", formData.backRight);
    fd_from.append("carry_dues", oldeDueCarry);

    const today = new Date().toISOString().split("T")[0];
    const pickupDateStr = formData.pickup_date
      ? new Date(formData.pickup_date).toISOString().split("T")[0]
      : null;
    if (pickupDateStr !== today) {
      fd_from.append("back_date_remark", formData.back_entry_reason);
    }
    setshowLoaderAdmin(true);
    await server_post_data(submit_update_pickup_data, fd_from)
      .then((Response) => {
        setshowLoaderAdmin(false);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          handleSuccessSession(Response.data.message, "/Bookings");
          setImageLink(APL_LINK + Response.data.message.other_images_link);
        }
      })
      .catch((error) => {
        setshowLoaderAdmin(false);
        handleError("network");
      });
  };

  const handleCarImageChange = async (e) => {
    const files = e.target.files;
    let data = await handleSaveImageBackend(e.target.files, "multi");
    if (files.length + formData.carImage.length <= 8) {
      const newFiles = Array.from(files);
      setFormData((prevData) => ({
        ...prevData,
        carImage: [...prevData.carImage, ...newFiles],
      }));
      setMultiCarData(data);
      setStep2Error((prev) => ({ ...prev, carImage: false }));
    } else {
      alert("You can upload a maximum of 8 images.");
    }
  };

  const handleRemoveImage = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      carImage: prevData.carImage.filter((_, i) => i !== index),
    }));
  };

  const handleRemoveImageSingleImg = (field, inputId) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: [],
    }));
    const inputElement = document.getElementById(inputId);
    if (inputElement) {
      inputElement.value = null; // Clear the file input field
    }
  };

  const handleChangeNotes = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    //console.log("dkjashkdjhaskjhdkashd", id);
    master_data_get();
  }, []);

  let defaultOwner;
  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("booking_id", id);
    await server_post_data(get_pickup_data_admin, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          const booking_data = Response.data.message.booking_data;
          const due_data = Response.data.message.old_dues;
          console.log("booking_data", Response.data.message);
          console.log("older dues", due_data);
          setCarData(Response.data.message.car_data);
          setOlderDueData(Response.data.message.old_dues);
          setBookingData(booking_data);
          if (due_data != 0) {
            setDueModal(true);
          }

          const cleanValue = (val) =>
            val === undefined ||
            val === null ||
            val === "" ||
            val === "undefined" ||
            val === "null"
              ? ""
              : val;

          let ipass_data = cleanValue(
            Response?.data?.message?.car_data?.ipass_number
          );

          console.log(
            "Response.data.message.car_data.ipass_number",
            Response.data.message.car_data.ipass_number
          );
          setUserId(booking_data.user_id);
          setCaripass(Response.data.message.data_ipass);
          setipassid(Response.data.message.car_data.ipass_id);
          console.log("ipassid", Response.data.message.car_data.ipass_id);
          setipassnumber(Response.data.message.car_data.ipass_number);
          console.log("dddddd", Response.data.message.car_data);
          const selectedCar = Response.data.message.data_ipass?.find(
            (item) => item.ipass_status === 1
            // isselected === 1
          );
          console.log("selectedCar", Response.data.message.data_ipass);

          // default owner selection
          defaultOwner =
            parseInt(selectedCar?.driver_id) === 0
              ? "Company Owned"
              : "Driver Owned";
          setVINNo(Response.data.message.car_data.vin);
          setFormData({
            pickup_date: new Date() || null,
            first_name: booking_data.first_name || "",
            last_name: booking_data.last_name || "",
            gaslavel: "",
            ipass: booking_data?.ipass_number,
            odoReading: "",
            insurance: "",
            time: "",
            dashboardOdoImage: null,

            // ipassImg: Response.data.message.car_data.ipass_image || "",
            ipassImg: "",
            // carImage: [],
            keyImg: null,
            InsuranceCopy: null,
            vinnumber: "",
            maintenance_due: booking_data.last_maintenance_date || "",
            registration_copy: null,
            inspection_copy: null,
            notes: "",
            ipass_owner: defaultOwner,
          });
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleSaveImageBackend = async (images, keyword, field) => {
    try {
      setshowLoaderAdmin(true);

      const fd = new FormData();
      if (keyword === "multi") {
        for (let i = 0; i < images.length; i++) {
          fd.append("image", images[i]); // Append each file
        }
      } else {
        fd.append("image", images); // Single image
      }
      fd.append("keyword", keyword);

      const response = await server_post_data(save_image_pdf_dashboard, fd);

      if (response.data.error) {
        handleError(response.data.message);
        setStep2Error((prev) => ({ ...prev, [field]: false }));
      } else {
        let data = response.data.message.image;
        setFormData((prevData) => ({
          ...prevData,
          [field]: data,
        }));
      }
      setImageLink(APL_LINK + response.data.message.image_link);
    } catch (error) {
      handleError("network");
    } finally {
      setshowLoaderAdmin(false);
    }
  };

  console.log(caripass, formData.ipass_owner);

  function formatDate(dateObj) {
    // console.log(dateObj);
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObj.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const [validationMessage, setValidationMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [addIPassModalOpen, setAddIPassModalOpen] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [dataIpassUser, setdataIpassUser] = useState([]);
  const [ipassformData, setIpassFormData] = useState({
    ipassNumber: "",
    ipassStatus: "",
    ipassNotes: "",
  });

  const handleChangeIpass = (e) => {
    const { name, value } = e.target;
    setIpassFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleChange = (e) => {
    const { name, type } = e.target;

    if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: e.target.checked }));
    } else if (type === "file") {
      setFormData((prev) => ({ ...prev, [name]: e.target.files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: e.target.value }));
    }
  };

  // Handle form reset
  const handleCancel = () => {
    // Reset form
    setFormData({
      ipassNumber: "",
      ipassStatus: "",
      ipassNotes: "",
    });
  };
  const handleAddIPassSubmit = async (e) => {
    e.preventDefault();

    // Example validation
    if (ipassformData?.ipassNumber.length < 5) {
      setValidationMessage("I-Pass number must be at least 5 characters long.");
      return;
    }

    // Simulating a server check for duplicate I-Pass numbers
    if (ipassformData?.ipassNumber === "12345") {
      setValidationMessage(
        "This I-Pass number already exists in the system. Please enter a unique number."
      );
      return;
    }

    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("ipass_no", ipassformData.ipassNumber);
    fd.append("status", ipassformData.ipassStatus);
    fd.append("notes", ipassformData.ipassNotes);
    fd.append("ipass_date", formatDate(startDate));
    fd.append("driver_id", userId);
    await server_post_data(save_car_ipass_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          // master_data_get(0, 0, 0);

          setdataIpassUser(Response.data.message.data_ipass);
          setCaripass(Response.data.message.data_ipass);
          setAddIPassModalOpen(false);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });

    // Show success message
    setSuccessMessage("I-Pass added successfully!");
    setAddIPassModalOpen(false);
  };

  const dataIpassUserFilter =
    caripass &&
    caripass.length > 0 &&
    caripass.filter((item) => item.driver_id > 0);

  //  const dataIpassUserFilter =
  // dataIpassUser &&
  // dataIpassUser.length > 0 &&
  // dataIpassUser.filter((item) => item.driver_id > 0);

  const cancelToggleStatus = () => {
    setDueModal(false);
  };
  const carryDues = (id) => {
    setOldeDueCarry(id);
    setDueModal(false);
  };

  const isTodayPickup = (() => {
    if (!formData.pickup_date) return false;
    const today = new Date().toISOString().split("T")[0];
    const pickupDateStr = new Date(formData.pickup_date)
      .toISOString()
      .split("T")[0];
    return pickupDateStr === today;
  })();

  useEffect(() => {
    if (formData.pickup_date) {
      const today = new Date().toISOString().split("T")[0];
      const pickupDateStr = new Date(formData.pickup_date)
        .toISOString()
        .split("T")[0];

      if (pickupDateStr === today) {
        setFormData((prev) => ({ ...prev, back_entry_reason: "" }));
      }
    }
  }, [formData.pickup_date]);

  const todayDate = new Date();
  const fourDaysAgoDate = new Date(Date.now() - 4 * 24 * 60 * 60 * 1000);

  // compute effective minDate based on backdate_entry
  const effectiveMinDate =
    formData.backdate_entry === "yes" ? fourDaysAgoDate : todayDate;

  console.log("effectiveMinDate", formData.ipass_owner);
  console.log("effectiveMinDate", ipassid);
  console.log("effectiveMinDate", ipassnumber);
  return (
    <div>
      {showLoaderAdmin && <Loader />}
      <Header />
      <div className="container-lg">
        <div className="pageCntn_head">
          <div className="pageNameDiv">
            <Breadcrumb
              items={[
                { label: "Bookings", path: "/Bookings" },
                {
                  label: "Pick-up Form",
                  path: "/PickUpForm/:id",
                },
              ]}
            />
          </div>
          <Button
            onClick={goBack}
            startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
            className="Back_bttn_page"
          >
            Back
          </Button>
        </div>

        <div className="mb-2 form-container PickUpFormContnr">
          {/*---------------------------step -1 --------------------- */}
          {activeStep === 1 && (
            <>
              <form>
                <div className="form-step">
                  <h6>Step 1: Pickup Overview & Vehicle Info</h6>

                  <div className="row">
                    <label className="col-md-6 mb-3">
                      <span>Are you making a back date entry? </span>

                      {/* Radio buttons for Yes/No */}
                      <div
                        className="check_box_mvr"
                        style={{ marginTop: "10px" }}
                      >
                        <input
                          type="radio"
                          id="mvrYes"
                          name="backdate_entry"
                          value="yes"
                          checked={formData.backdate_entry === "yes"}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                        <label htmlFor="mvrYes" style={{ marginRight: "20px" }}>
                          Yes
                        </label>

                        <input
                          type="radio"
                          id="mvrNo"
                          name="backdate_entry"
                          value="no"
                          checked={formData.backdate_entry === "no"}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                        <label htmlFor="mvrNo">No</label>
                      </div>

                      {step1Error.backdate_entry && (
                        <span style={{ color: "red" }}>
                          Please Select an option
                        </span>
                      )}
                    </label>
                    <div className="col-md-6 mb-3 ">
                      <label>
                        Pickup Date
                        <span style={{ color: "red" }}>*</span>
                      </label>

                      <DatePicker
                        selected={formData.pickup_date}
                        onChange={(date) => {
                          const formattedDate = date
                            ? `${date.getFullYear()}-${String(
                                date.getMonth() + 1
                              ).padStart(2, "0")}-${String(
                                date.getDate()
                              ).padStart(2, "0")}`
                            : "";
                          handleDateChange(
                            formattedDate,
                            "pickup_date",
                            setStep1Error
                          );
                        }}
                        dateFormat="MM-dd-yyyy"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="search-input datepicker form-control"
                        placeholder="Pickup Date"
                        // minDate={new Date()}
                        minDate={effectiveMinDate}
                        maxDate={new Date()}
                      />
                      {step1Error.pickup_date && (
                        <span style={{ color: "red" }}>
                          Please fill this field
                        </span>
                      )}
                    </div>
                    {formData.backdate_entry === "yes" && !isTodayPickup && (
                      <div className="col-md-6 mb-3">
                        <label className="insncE_lbl">
                          Reason for back date entry
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          name="back_entry_reason"
                          value={formData.back_entry_reason}
                          className="form-control"
                          onChange={handleChange}
                        />
                        {step1Error.back_entry_reason && (
                          <span style={{ color: "red" }}>
                            Please fill this field
                          </span>
                        )}
                      </div>
                    )}
                    <div className="col-md-6 mb-3 d-flex flex-column">
                      <label className="insncE_lbl">
                        Insurance By
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <ButtonGroup
                        className="insurenceBttnGrp"
                        variant="outlined"
                        aria-label="Insurance Options"
                      >
                        <Button
                          onClick={() =>
                            handleInputChange(
                              { target: { value: "Tripcity" } },
                              "insurance",
                              1
                            )
                          }
                          className={`${
                            formData.insurance === "Tripcity" ? "active" : ""
                          } insurance-btn`}
                        >
                          Tripcity
                        </Button>
                        <Button
                          onClick={() =>
                            handleInputChange(
                              { target: { value: "Direct" } },
                              "insurance",
                              1
                            )
                          }
                          className={`${
                            formData.insurance === "Direct" ? "active" : ""
                          } insurance-btn`}
                        >
                          Direct
                        </Button>
                      </ButtonGroup>
                      {step1Error.insurance && (
                        <span style={{ color: "red" }}>
                          Please select an option
                        </span>
                      )}
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>
                        Agreement and Deposit / Payment
                        <span style={{ color: "red" }}>*</span>
                      </label>

                      <div className="checkBoxexAgrrmnt">
                        <div className="form_check_contr">
                          <div
                            className="form-check"
                            onClick={handleAgreementChange}
                            style={{ cursor: "pointer" }}
                          >
                            <input
                              type="checkbox"
                              id="agreementCheckbox"
                              checked={agreementChecked}
                              onChange={handleAgreementChange}
                            />
                            <p>Agreement Received</p>
                          </div>
                          {step1Error.agreement && (
                            <span
                              className="agrymntError"
                              style={{ color: "red" }}
                            >
                              Please check this field
                            </span>
                          )}
                        </div>
                        <div className="form_check_contr">
                          <div
                            className="form-check"
                            onClick={handlePaymentChange}
                            style={{ cursor: "pointer" }}
                          >
                            <input
                              type="checkbox"
                              id="agreementCheckbox"
                              checked={paymentChecked}
                              onChange={handlePaymentChange}
                            />
                            <p>Payment Received</p>
                          </div>
                          {step1Error.payment && (
                            <span
                              className="agrymntError"
                              style={{ color: "red" }}
                            >
                              Please check this field
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>
                        Deposit / Payment
                        <span style={{ color: "red" }}>*</span>
                      </label>

                      <div className="checkBoxexAgrrmnt">
                        <div className="form_check_contr">
                          <div
                            className="form-check"
                            onClick={handleAgreementChange}
                            style={{ cursor: "pointer" }}
                          >
                            <p>Deposit Amount : {BookingData?.total_deposit}</p>
                          </div>
                        </div>
                        <div className="form_check_contr">
                          <div
                            className="form-check"
                            onClick={handlePaymentChange}
                            style={{ cursor: "pointer" }}
                          >
                            <p>Due Amount : {BookingData?.due_deposit}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3 time_Div_contr">
                      <label className="insncE_lbl">
                        Time
                        <span style={{ color: "red" }}>*</span>
                      </label>

                      <select
                        className="form-select"
                        value={formData.time}
                        onChange={(e) => handleInputChange(e, "time", 1)}
                      >
                        <option value="" disabled>
                          Select Time
                        </option>
                        <option value="Morning">Morning</option>
                        <option value="Evening">Afternoon</option>
                        <option value="Late Night">Evening</option>
                      </select>
                      {step1Error.time && (
                        <span style={{ color: "red" }}>
                          Please select an option
                        </span>
                      )}
                    </div>
                    <div className="col-md-12 mb-3 carDetlCntr">
                      <label className="insncE_lbl">All Car Details</label>
                      <p>
                        {carData.car_tagline} / {carData.car_name} / LP#:{" "}
                        {carData.car_no} / VIN#: {carData.vin} / Make Year:{" "}
                        {carData.make_year} / Model: {carData.model_name}
                      </p>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="insncE_lbl">
                        Fist Name
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        value={formData.first_name}
                        className="form-control"
                        onInput={handleAphabetsChange}
                        onChange={(e) => handleInputChange(e, "first_name", 1)}
                        maxLength={50}
                      ></input>
                      {step1Error.first_name && (
                        <span style={{ color: "red" }}>
                          Please fill this field
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>
                        Last Name
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control"
                        value={formData.last_name}
                        onInput={handleAphabetsChange}
                        onChange={(e) => handleInputChange(e, "last_name", 1)}
                      ></input>
                      {step1Error.last_name && (
                        <span style={{ color: "red" }}>
                          Please fill this field
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </form>
              <div className="Next_preV_bck_bttn">
                <div className="nextBttnDiv">
                  <Button onClick={handleNext} color="primary">
                    Next
                  </Button>
                </div>
              </div>
            </>
          )}
          {/*---------------------------step -2 --------------------- */}

          {activeStep === 2 && (
            <>
              <form>
                {" "}
                <div className="form-step">
                  <h6>Step 2 : Vehicle Condition & Verification</h6>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      {" "}
                      <label className="insncE_lbl">
                        Gas Level
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      {/* <input
                                                value={formData.gaslavel}
                                                className="form-control"
                                                onInput={handleNumbersChange}
                                                maxLength={2}
                                                onChange={(e) => handleInputChange(e, "gaslavel", 2)}
                                            ></input>
                                            {step2Error.gaslavel && (
                                                <span style={{ color: "red" }}>
                                                    Please fill this field
                                                </span>
                                            )} */}
                      <div className="repo-gas-level">
                        <div className="repo-gas-gauge">
                          <div className="repo-gas-indicator">
                            <div className="repo-gas-level-marks mt-2">
                              {[...Array(11)].map((_, i) => (
                                <div
                                  key={i}
                                  className={`repo-gas-mark ${
                                    Number(formData.gaslavel) >= i
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  {i % 2 === 0 && (
                                    <span className="repo-gas-mark-label">
                                      {i}
                                    </span>
                                  )}
                                </div>
                              ))}
                            </div>
                            <input
                              type="range"
                              min="0"
                              max="10"
                              step="1"
                              value={formData.gaslavel || 0}
                              onChange={handleGasLevelChange}
                              className="repo-range-input"
                            />
                          </div>
                          <div className="repo-gas-input-group">
                            <span className="repo-gas-label">Fuel Level:</span>
                            <div className="repo-gas-input">
                              <input
                                type="number"
                                value={formData.gaslavel}
                                onChange={handleGasLevelChange}
                                min="0"
                                max="10"
                                className="repo-number-input"
                              />
                              <span className="repo-gas-max">/10</span>
                            </div>
                          </div>
                          {step2Error.gaslavel && (
                            <span style={{ color: "red" }}>
                              Select the Gas Level
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "15px",
                      }}
                    >
                      <div className="col-md-6 mb-3">
                        {" "}
                        <label className="insncE_lbl">
                          Odometer Reading (ODO)
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          value={formData.odoReading}
                          className="form-control file_custm_Pdding"
                          onInput={handleNumbersChange}
                          maxLength={10}
                          onChange={(e) =>
                            handleInputChange(e, "odoReading", 2)
                          }
                        ></input>
                        {step2Error.odoReading && (
                          <span style={{ color: "red" }}>
                            Please fill this field
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="insncE_lbl">
                          Picture of Dashboard (ODO & GAS)
                          <span style={{ color: "red" }}>*</span>
                        </label>

                        {!formData.dashboardOdoImage ||
                        formData.dashboardOdoImage.length === 0 ? (
                          <input
                            id="dashboardOdoImageInput"
                            type="file"
                            className="form-control file_custm_Pdding"
                            onChange={(e) =>
                              handleFileChange(e, "dashboardOdoImage")
                            }
                          />
                        ) : (
                          <div className="image-preview">
                            <img
                              src={imageLink + formData.dashboardOdoImage}
                              alt="Preview"
                              style={{ height: "100px", width: "100px" }}
                            />
                            <X
                              className="removeBttn"
                              size={18}
                              onClick={() =>
                                handleRemoveImageSingleImg(
                                  "dashboardOdoImage",
                                  "dashboardOdoImageInput"
                                )
                              }
                            />
                          </div>
                        )}

                        {/* Error message for the missing image */}
                        {step2Error.dashboardOdoImage && (
                          <span style={{ color: "red" }}>
                            Please upload an image
                          </span>
                        )}
                      </div>
                    </div>

                    <label className="picture_car_lbl">
                      {" "}
                      Pictures of the car
                    </label>
                    {/* Front Left */}
                    <div
                      className={
                        !formData.frontLeft
                          ? "col-md-6 col-lg-3 mb-3"
                          : "col-md-3 col-lg-2 mb-3"
                      }
                    >
                      <label htmlFor="frontLeftImage" className="form-label">
                        Driver Left <span style={{ color: "red" }}>*</span>
                      </label>
                      {console.log("forn_img", formData.frontLeft)}
                      {!formData.frontLeft ||
                      formData.frontLeft.length === 0 ? (
                        <input
                          id="frontLeftImage"
                          type="file"
                          accept=".png, .jpg, .jpeg, .heic, .heif"
                          className="form-control file_custm_Pdding"
                          onChange={(e) => handleFileChange(e, "frontLeft")}
                        />
                      ) : (
                        <div
                          className="image-preview mt-2"
                          style={{ position: "relative" }}
                        >
                          <img
                            src={imageLink + formData.frontLeft}
                            alt="Front Left"
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "6px",
                            }}
                          />

                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImageSingleImg(
                                "frontLeft",
                                "frontLeftImage"
                              )
                            }
                          />
                        </div>
                      )}
                      {step2Error.frontLeft && (
                        <span style={{ color: "red", fontSize: "13px" }}>
                          Please upload Driver Left image
                        </span>
                      )}
                    </div>

                    {/* Front Right */}
                    <div
                      className={
                        !formData.frontRight
                          ? "col-md-6 col-lg-3 mb-3"
                          : "col-md-3 col-lg-2 mb-3"
                      }
                    >
                      <label htmlFor="frontRightImage" className="form-label">
                        Driver Right <span style={{ color: "red" }}>*</span>
                      </label>
                      {!formData.frontRight ||
                      formData.frontRight.length === 0 ? (
                        <input
                          id="frontRightImage"
                          type="file"
                          accept=".png, .jpg, .jpeg, .heic, .heif"
                          className="form-control file_custm_Pdding"
                          onChange={(e) => handleFileChange(e, "frontRight")}
                        />
                      ) : (
                        <div
                          className="image-preview mt-2"
                          style={{ position: "relative" }}
                        >
                          <img
                            src={imageLink + formData.frontRight}
                            alt="Front Right"
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "6px",
                            }}
                          />

                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImageSingleImg("frontRight")
                            }
                          />
                        </div>
                      )}
                      {step2Error.frontRight && (
                        <span style={{ color: "red", fontSize: "13px" }}>
                          Please upload Driver Right image
                        </span>
                      )}
                    </div>

                    {/* Back Left */}
                    <div
                      className={
                        !formData.backLeft
                          ? "col-md-6 col-lg-3 mb-3"
                          : "col-md-3 col-lg-2 mb-3"
                      }
                    >
                      <label htmlFor="backLeftImage" className="form-label">
                        Passanger Left <span style={{ color: "red" }}>*</span>
                      </label>{" "}
                      {!formData.backLeft || formData.backLeft.length === 0 ? (
                        <input
                          id="backLeftImage"
                          type="file"
                          accept=".png, .jpg, .jpeg, .heic, .heif"
                          className="form-control file_custm_Pdding"
                          onChange={(e) => handleFileChange(e, "backLeft")}
                        />
                      ) : (
                        <div
                          className="image-preview mt-2"
                          style={{ position: "relative" }}
                        >
                          <img
                            src={imageLink + formData.backLeft}
                            alt="Back Left"
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "6px",
                            }}
                          />

                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImageSingleImg("backLeft")
                            }
                          />
                        </div>
                      )}
                      {step2Error.backLeft && (
                        <span style={{ color: "red", fontSize: "13px" }}>
                          Please upload Passanger Left image
                        </span>
                      )}
                    </div>

                    {/* Back Right */}
                    <div
                      className={
                        !formData.backRight
                          ? "col-md-6 col-lg-3 mb-3"
                          : "col-md-3 col-lg-2 mb-3"
                      }
                    >
                      <label htmlFor="backRightImage" className="form-label">
                        Passanger Right <span style={{ color: "red" }}>*</span>
                      </label>
                      {!formData.backRight ||
                      formData.backRight.length === 0 ? (
                        <input
                          id="backRightImage"
                          type="file"
                          accept=".png, .jpg, .jpeg, .heic, .heif"
                          className="form-control file_custm_Pdding"
                          onChange={(e) => handleFileChange(e, "backRight")}
                        />
                      ) : (
                        <div
                          className="image-preview mt-2"
                          style={{ position: "relative" }}
                        >
                          <img
                            src={imageLink + formData.backRight}
                            alt="Back Right"
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "6px",
                            }}
                          />

                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImageSingleImg("backRight")
                            }
                          />
                        </div>
                      )}
                      {step2Error.backRight && (
                        <span style={{ color: "red", fontSize: "13px" }}>
                          Please upload Passanger Right image
                        </span>
                      )}
                    </div>

                    {/* IPASS Picture */}
                    <div
                      className={
                        !formData.ipassImg
                          ? "col-md-6 col-lg-3 mb-3"
                          : "col-md-3 col-lg-2 mb-3"
                      }
                    >
                      <label>
                        IPASS Picture
                        <span style={{ color: "red" }}>*</span>
                      </label>

                      {!formData.ipassImg || formData.ipassImg.length === 0 ? (
                        <input
                          id="ipassImg"
                          type="file"
                          className="form-control file_custm_Pdding2"
                          onChange={(e) => handleFileChange(e, "ipassImg")}
                          accept=".png, .jpg, .jpeg, .heic, .heif"
                        />
                      ) : (
                        // Show image preview if an image is uploaded
                        <div
                          className="image-preview mt-2"
                          style={{ position: "relative" }}
                        >
                          <img
                            src={imageLink + formData.ipassImg}
                            alt="Preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "6px",
                            }}
                          />

                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImageSingleImg("ipassImg", "ipassImg")
                            }
                          />
                        </div>
                      )}
                      {step2Error.ipassImg && (
                        <span style={{ color: "red" }}>
                          Please upload an image
                        </span>
                      )}
                    </div>

                    {/* Picture of the Key (Showing All Buttons) */}
                    <div
                      className={
                        !formData.keyImg
                          ? "col-md-6 col-lg-3 mb-3"
                          : "col-md-3 col-lg-2 mb-3"
                      }
                    >
                      <label>
                        Picture of the Key{" "}
                        <span style={{ color: "red" }}>*</span>
                        <span
                          style={{
                            fontSize: "11px",
                            color: "var(--primary-color)",
                          }}
                        >
                          {" "}
                          (Show All Buttons)
                        </span>
                      </label>
                      {!formData.keyImg || formData.keyImg.length === 0 ? (
                        <input
                          type="file"
                          className="form-control file_custm_Pdding2"
                          onChange={(e) => handleFileChange(e, "keyImg")}
                          accept=".png, .jpg, .jpeg, .heic, .heif"
                        />
                      ) : (
                        <div
                          className="image-preview mt-2"
                          style={{ position: "relative" }}
                        >
                          <img
                            src={imageLink + formData.keyImg}
                            alt="Preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "6px",
                            }}
                          />

                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImageSingleImg("keyImg", "keyImg")
                            }
                          />
                        </div>
                      )}
                      {step2Error.keyImg && (
                        <span style={{ color: "red" }}>
                          Please upload an image
                        </span>
                      )}
                    </div>

                    <div className="col-12 mb-3">
                      <div className="col-md-6 mb-3">
                        <label className="insncE_lbl">
                          I-Pass Ownership
                          {/* (Last 5 Digits of IPASS #) */}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="terms-radio-group d-flex gap-3">
                          {["Company Owned", "Driver Owned"].map((option) => (
                            <div className="check_box_dvv" key={option}>
                              <input
                                type="radio"
                                id={option.substring(0, 10).replace(/\s+/g, "")}
                                name="ipass_owner"
                                defaultChecked={formData?.ipass_owner == option}
                                onClick={() => {
                                  handleInputChange(
                                    { target: { value: option } },
                                    "ipass_owner",
                                    1
                                  );
                                }}
                                // checked={
                                //   BookingData.ipass_owner === option
                                //     ? true
                                //     : false
                                // }
                                // checked={defaultOwner === option}
                              />
                              <label
                                htmlFor={option
                                  .substring(0, 10)
                                  .replace(/\s+/g, "")}
                              >
                                {option}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="row m-0">
                        <div className="col-md-6 mb-3">
                          {" "}
                          <label className="insncE_lbl">
                            IPASS
                            {/* (Last 5 Digits of IPASS #) */}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            className="form-select ipass-select"
                            value={ipassid}
                            onChange={(e) => handleInputChange(e, "ipass", 2)}
                          >
                            <option value="" hidden>
                              Select Ipass
                            </option>
                            {console.log(
                              "caripass",
                              caripass,
                              dataIpassUserFilter
                            )}
                            {formData?.ipass_owner == "Company Owned" ? (
                              <>
                                <option value={ipassid}>{ipassnumber}</option>
                                {caripass &&
                                  caripass.length > 0 &&
                                  caripass.map(
                                    (item, index) =>
                                      item.driver_id == 0 && (
                                        <option
                                          key={index}
                                          value={`${item.primary_id}`}
                                          selected={item.isselected === 1}
                                        >
                                          {item.ipass_id}
                                        </option>
                                      )
                                  )}
                              </>
                            ) : (
                              <>
                                {dataIpassUserFilter &&
                                  dataIpassUserFilter.length > 0 &&
                                  dataIpassUserFilter.map((item, index) => (
                                    <option
                                      key={index}
                                      value={`${item.primary_id}`}
                                      selected={item.isselected === 1}
                                    >
                                      {item.ipass_id}
                                    </option>
                                  ))}
                              </>
                            )}
                          </select>
                          {step2Error.ipass && (
                            <span style={{ color: "red" }}>
                              Please fill this field
                            </span>
                          )}
                        </div>
                        {formData.ipass_owner != "Company Owned" && (
                          <div className="col-md-6 mb-3 d-flex align-items-end">
                            <button
                              className="btn btn-primary ipass-btn-icon"
                              onClick={() => setAddIPassModalOpen(true)}
                              type="button"
                            >
                              <Plus size={18} />
                              Add New I-Pass
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div className="Next_preV_bck_bttn">
                {" "}
                <div className="nextBttnDiv">
                  <div className="nextBttnDiv">
                    <Button
                      className="back_step_btn"
                      onClick={handleBack}
                      color="primary"
                    >
                      Back
                    </Button>
                  </div>
                </div>
                <div className="nextBttnDiv">
                  <Button onClick={handleNext2} color="primary">
                    Next
                  </Button>
                </div>
              </div>
            </>
          )}

          {/*---------------------------step -3 --------------------- */}
          {activeStep === 3 && (
            <>
              <form>
                {" "}
                <div className="form-step">
                  <h6>Step 3 : Compliance & Documentation</h6>
                  <div className="row">
                    <div className="col-md-6 mb-3 ">
                      <label>
                        Last Maintenance Done On
                        <span style={{ color: "red" }}>*</span>
                      </label>

                      <DatePicker
                        selected={formData.maintenance_due}
                        onChange={(date) =>
                          handleDateChange(
                            date,
                            "maintenance_due",
                            setStep3Error
                          )
                        }
                        dateFormat="dd-MM-yyyy"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="search-input datepicker form-control custm_pdding_date_pickr"
                      />
                      {step3Error.maintenance_due && (
                        <span style={{ color: "red" }}>
                          Please fill this field
                        </span>
                      )}
                    </div>
                    {/* Copy of Insurance */}
                    <div
                      className={
                        !formData.InsuranceCopy ||
                        formData.InsuranceCopy.length === 0
                          ? "col-md-6 mb-3"
                          : "col-md-3 col-lg-2 mb-3"
                      }
                    >
                      <label>
                        Copy of Insurance
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      {/* Show file input if no image is uploaded */}
                      {!formData.InsuranceCopy ||
                      formData.InsuranceCopy.length === 0 ? (
                        <input
                          id="InsuranceCopy"
                          type="file"
                          className="form-control file_custm_Pdding3"
                          onChange={(e) =>
                            handleFileChange2(e, "InsuranceCopy")
                          }
                          accept=".png, .jpg, .jpeg, .heic, .heif"
                        />
                      ) : (
                        // Show image preview if an image is uploaded
                        <div
                          className="image-preview mt-2"
                          style={{ position: "relative" }}
                        >
                          <img
                            src={imageLink + formData.InsuranceCopy}
                            alt="Preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "6px",
                            }}
                          />

                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImageSingleImg(
                                "InsuranceCopy",
                                "InsuranceCopy"
                              )
                            }
                          />
                        </div>
                      )}

                      {step3Error.InsuranceCopy && (
                        <span style={{ color: "red" }}>
                          Please upload an image
                        </span>
                      )}
                    </div>
                    {/* Copy of Inspection */}
                    <div
                      className={
                        !formData.inspection_copy ||
                        formData.inspection_copy.length === 0
                          ? "col-md-6 mb-3"
                          : "col-md-3 col-lg-2 mb-3"
                      }
                    >
                      <label>
                        Copy of Inspection
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      {!formData.inspection_copy ||
                      formData.inspection_copy.length === 0 ? (
                        <input
                          id="inspection_copy"
                          type="file"
                          className="form-control file_custm_Pdding3"
                          onChange={(e) =>
                            handleFileChange2(e, "inspection_copy")
                          }
                          accept=".png, .jpg, .jpeg, .heic, .heif"
                        />
                      ) : (
                        <div
                          className="image-preview mt-2"
                          style={{ position: "relative" }}
                        >
                          <img
                            src={imageLink + formData.inspection_copy}
                            alt="Preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "6px",
                            }}
                          />

                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImageSingleImg(
                                "inspection_copy",
                                "inspection_copy"
                              )
                            }
                          />
                        </div>
                      )}
                      {step3Error.inspection_copy && (
                        <span style={{ color: "red" }}>
                          Please upload an image
                        </span>
                      )}
                    </div>

                    {/* Copy of Registration */}
                    <div
                      className={
                        !formData.registration_copy ||
                        formData.registration_copy.length === 0
                          ? "col-md-6 mb-3"
                          : "col-md-3 col-lg-2 mb-3"
                      }
                    >
                      <label>
                        Copy of Registration
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      {/* Show file input if no image is uploaded */}
                      {!formData.registration_copy ||
                      formData.registration_copy.length === 0 ? (
                        <input
                          id="registration_copy"
                          type="file"
                          className="form-control file_custm_Pdding3"
                          onChange={(e) =>
                            handleFileChange2(e, "registration_copy")
                          }
                          accept=".png, .jpg, .jpeg, .heic, .heif"
                        />
                      ) : (
                        // Show image preview if an image is uploaded
                        <div
                          className="image-preview mt-2"
                          style={{ position: "relative" }}
                        >
                          <img
                            src={imageLink + formData.registration_copy}
                            alt="Preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "6px",
                            }}
                          />

                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImageSingleImg(
                                "registration_copy",
                                "registration_copy"
                              )
                            }
                          />
                        </div>
                      )}
                      {step3Error.registration_copy && (
                        <span style={{ color: "red" }}>
                          Please upload an image
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>
                        Match Last 6 Digits of VIN ({`${VINNo}`})
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control file_custm_Pdding3"
                        value={formData.vinnumber}
                        onInput={handleNumbersChange}
                        onChange={(e) => handleInputChange(e, "vinnumber", 2)}
                        maxLength={6}
                        minLegth={6}
                      ></input>
                      {step3Error.vinnumber && (
                        <span style={{ color: "red" }}>{errors.vinnumber}</span>
                      )}
                    </div>
                  </div>
                </div>
              </form>
              <div className="Next_preV_bck_bttn">
                {" "}
                <div className="nextBttnDiv">
                  <div className="nextBttnDiv">
                    <Button
                      className="back_step_btn"
                      onClick={handleBack}
                      color="primary"
                    >
                      Back
                    </Button>
                  </div>
                </div>
                <div className="nextBttnDiv">
                  <Button onClick={handleNext3} color="primary">
                    Next
                  </Button>
                </div>
              </div>
            </>
          )}
          {/*---------------------------step -4 --------------------- */}
          {activeStep === 4 && (
            <>
              <form>
                <div className="form-step">
                  <h6>Step 4 : Final Checks & Remarks</h6>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label>
                        Checklist
                        <span style={{ color: "red" }}>*</span>
                      </label>

                      <div className="checkBoxexAgrrmnt">
                        <div className="form_check_contr">
                          {/* {checkboxes.map((label, index) => (
                            <div
                              className="form-check"
                              key={index}
                              onClick={() => handleCheckboxChange(label)}
                              style={{ cursor: "pointer" }}
                            >
                              <input
                                type="checkbox"
                                // checked={checkedItems.includes(label)}
                                defaultChecked={
                                  label != "2nd Key Check"
                                    ? true
                                    : checkedItems.includes(label)
                                }
                              />
                              <p>{label}</p>
                            </div>
                          ))} */}
                          {checkboxes.map((label, index) => (
                            <div
                              className="form-check"
                              key={index}
                              style={{ cursor: "pointer" }}
                            >
                              <input
                                type="checkbox"
                                checked={
                                  Array.isArray(checkedItems) &&
                                  checkedItems.includes(label)
                                }
                                onChange={() => handleCheckboxChange(label)}
                                id={`chk-${index}`}
                              />
                              <label
                                htmlFor={`chk-${index}`}
                                style={{ marginLeft: 8 }}
                              >
                                {label}
                              </label>
                            </div>
                          ))}
                          {step4Error.checkedItems && (
                            <span style={{ color: "red" }}>
                              All checkboxes must be selected.
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>Notes (Additional Comments)</label>
                      <textarea
                        name="notes"
                        type="text"
                        className="form-control noteSection"
                        value={formData.notes}
                        onChange={handleChangeNotes}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </form>
              <div className="Next_preV_bck_bttn">
                {" "}
                <div className="nextBttnDiv">
                  <div className="nextBttnDiv">
                    <Button
                      className="back_step_btn"
                      onClick={handleBack}
                      color="primary"
                    >
                      Back
                    </Button>
                  </div>
                </div>
                <div className="nextBttnDiv">
                  <Button type="button" onClick={handleNext4} color="primary">
                    Submit
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Add I-Pass Modal */}
      <Modal
        show={addIPassModalOpen}
        onHide={() => setAddIPassModalOpen(false)}
        size="lg"
        centered
        className="ipass-modal"
      >
        <Modal.Header
          style={{ backgroundColor: "var(--primary-color)" }}
          closeButton
        >
          <Modal.Title style={{ color: "#fff" }}>Add New I-Pass</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid p-0">
            <div className="">
              {/* Form Section */}
              <div className="col-lg">
                <div className="ipass-form-container">
                  <h3 className="h5 mb-4">I-Pass Details</h3>

                  <form onSubmit={handleAddIPassSubmit}>
                    <div className="mb-3">
                      <label
                        htmlFor="ipassNumber"
                        className="form-label ipass-form-label"
                      >
                        I-Pass Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="ipassNumber"
                        name="ipassNumber"
                        value={ipassformData.ipassNumber}
                        onChange={handleChangeIpass}
                        placeholder="Enter unique I-Pass number"
                        required
                      />
                      <div className="form-text ipass-form-text">
                        Must be a unique identifier for this device
                      </div>
                    </div>

                    <div
                      className="mb-3"
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      <div className="col-md-5">
                        <label
                          htmlFor="refund-date"
                          className="accounting-label"
                        >
                          Date
                        </label>
                        <div className="accounting-date-input-wrapper">
                          <DatePicker
                            id="start-date"
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            className="accounting-date-input form-control borderRadiusnew mt-0"
                            placeholderText="MM/DD/YYYY"
                            dateFormat="MM/dd/yyyy"
                            maxDate={new Date()}
                          />
                          <Calendar
                            className="accounting-date-icon"
                            size={18}
                          />
                        </div>
                      </div>

                      <div className="col-md-5">
                        <label
                          htmlFor="ipassStatus"
                          className="form-label ipass-form-label"
                        >
                          Status <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          id="ipassStatus"
                          name="ipassStatus"
                          value={ipassformData.ipassStatus}
                          onChange={handleChangeIpass}
                          required
                        >
                          <option value="" disabled>
                            Select status
                          </option>
                          <option value="1">Active</option>
                          <option value="0">Inactive</option>
                        </select>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label
                        htmlFor="ipassNotes"
                        className="form-label ipass-form-label"
                      >
                        Notes (Optional)
                      </label>
                      <textarea
                        className="form-control"
                        id="ipassNotes"
                        name="ipassNotes"
                        rows="3"
                        value={ipassformData.ipassNotes}
                        onChange={handleChangeIpass}
                        placeholder="Add any additional information about this I-Pass"
                      ></textarea>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              handleCancel();
              setAddIPassModalOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button
            style={{
              backgroundColor: "var(--primary-color)",
              border: "none",
              color: "#ffffff",
            }}
            onClick={handleAddIPassSubmit}
          >
            Save I-Pass
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Past Dues Reminder Modal */}
      <Modal
        className="statusModal"
        backdrop="static"
        centered
        size="md"
        show={dueModal}
        // show={true}
        onHide={cancelToggleStatus}
      >
        <Modal.Body>
          <div className="statusContntDiv">
            {" "}
            <div className="d-flex flex-column align-items-center gap-3">
              <img src={UserIconOrenge} alt="UserIconOrenge"></img>
              <p className="px-3">{duescontnt}</p>
              <div className="StatusDecideBttn">
                <button className="yesBtnStasus" onClick={() => carryDues(1)}>
                  Yes
                </button>
                <button
                  className="noBtnStsus"
                  onClick={() => navigate("/Bookings")}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
